exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-c6555d1c]{color:red;font-size:11px}a.button-submit[data-v-c6555d1c]{background-color:red;color:#fff!important;padding:10px 20px;text-decoration:none;border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6555d1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/PmInvestors.vue
// module id = 280
// module chunks = 0